// src/data/penaltyClaimPdf.js
//
// RULING 257 (proposed 2026-09-29, preview only). The Penalty Time Claim as a real PDF, written directly
// (PDF 1.4, no library - ycp.ps1 installs no packages). Takes the form model from penaltyClaim.js.
//
// Bob's layout rules, 2026-09-29:
//   - One page is the target. Never at the cost of legibility: body type never under 11 pt, margins never
//     under 3/4 inch, nothing shrunk to fit, nothing cut. As many pages as a proper claim needs.
//   - Every page names the claim number, the claimant and "Page X of Y".
//   - The signature and receipt block never splits, and never stands alone - the payment paragraph above
//     it always travels with it. A heading never ends a page. No single stranded line of a paragraph.
//   - Letterhead: the SMART-TD header from Bob's own later office letters (SMART logo, "* Our Union - Our
//     Jobs - Our Lives - Our Future *", rule, the General Chairperson's line, rule). Office lines print
//     only from the platform's record or the committee's own letterhead (ruling 236) - never guessed.
//   - Fillable boxes (AcroForm text fields) for any blank entry (employee no., submission date, hours) and
//     for the signing date and the date and time received. The SIGNATURE LINES are left for the signer's
//     own mark (pen, or Acrobat "Fill & Sign" / Mac Preview / Edge) - the platform never signs (237/238).
// Pure: returns bytes. Adds no words of its own beyond the form's fixed labels.

const W = {
  R: [250,333,408,500,500,833,778,180,333,333,500,564,250,333,250,278,500,500,500,500,500,500,500,500,500,500,278,278,564,564,564,444,921,722,667,667,722,611,556,722,722,333,389,722,611,889,722,722,556,722,667,556,611,722,722,944,722,722,611,333,278,333,469,500,333,444,500,444,500,444,333,500,500,278,278,500,278,778,500,500,500,500,333,389,278,500,500,722,500,500,444,480,200,480,541,350,500,350,333,500,444,1000,500,500,333,1000,556,333,889,350,611,350,350,333,333,444,444,350,500,1000,333,980,389,333,722,350,444,722,250,333,500,500,500,500,200,500,333,760,276,500,564,333,760,333,400,564,300,300,333,500,453,250,333,300,310,500,750,750,750,444,722,722,722,722,722,722,889,667,611,611,611,611,333,333,333,333,722,722,722,722,722,722,722,564,722,722,722,722,722,722,556,500,444,444,444,444,444,444,667,444,444,444,444,444,278,278,278,278,500,500,500,500,500,500,500,564,500,500,500,500,500,500,500,500],
  B: [250,333,555,500,500,1000,833,278,333,333,500,570,250,333,250,278,500,500,500,500,500,500,500,500,500,500,333,333,570,570,570,500,930,722,667,722,722,667,611,778,778,389,500,778,667,944,722,778,611,778,722,556,667,722,722,1000,722,722,667,333,278,333,581,500,333,500,556,444,556,444,333,500,556,278,333,556,278,833,556,500,556,556,444,389,333,556,500,722,500,500,444,394,220,394,520,350,500,350,333,500,500,1000,500,500,333,1000,556,333,1000,350,667,350,350,333,333,500,500,350,500,1000,333,1000,389,333,722,350,444,722,250,333,500,500,500,500,220,500,333,747,300,500,570,333,747,333,400,570,300,300,333,556,540,250,333,300,330,500,750,750,750,500,722,722,722,722,722,722,1000,722,667,667,667,667,389,389,389,389,722,722,778,778,778,778,778,570,778,722,722,722,722,722,611,556,500,500,500,500,500,500,722,444,444,444,444,444,278,278,278,278,500,556,500,500,500,500,500,570,500,556,556,556,556,500,556,500],
  I: [250,333,420,500,500,833,778,214,333,333,500,675,250,333,250,278,500,500,500,500,500,500,500,500,500,500,333,333,675,675,675,500,920,611,611,667,722,611,611,722,722,333,444,667,556,833,667,722,611,722,611,500,556,722,611,833,611,556,556,389,278,389,422,500,333,500,500,444,500,444,278,500,500,278,278,444,278,722,500,500,500,500,389,389,278,500,444,667,444,444,389,400,275,400,541,350,500,350,333,500,556,889,500,500,333,1000,500,333,944,350,556,350,350,333,333,556,556,350,500,889,333,980,389,333,667,350,389,556,250,389,500,500,500,500,275,500,333,760,276,500,675,333,760,333,400,675,300,300,333,500,523,250,333,300,310,500,750,750,750,500,611,611,611,611,611,611,889,667,611,611,611,611,333,333,333,333,722,667,722,722,722,722,722,675,722,722,722,722,722,556,611,500,500,500,500,500,500,500,667,444,444,444,444,444,278,278,278,278,500,500,500,500,500,500,500,675,500,500,500,500,500,444,500,444],
  // Helvetica, ASCII 32..126 only (used for the one-line motto of the letterhead).
  H: [278,278,355,556,556,889,667,191,333,333,389,584,278,333,278,278,556,556,556,556,556,556,556,556,556,556,278,278,584,584,584,556,1015,667,667,722,722,667,611,778,722,278,500,667,556,833,722,778,667,778,722,667,611,722,667,944,667,667,611,278,278,278,469,556,333,556,556,500,556,556,278,556,556,222,222,500,222,833,556,556,556,556,333,500,278,556,500,722,500,500,500,334,260,334,584],
};
const FONT_NAME = { R: 'Times-Roman', B: 'Times-Bold', I: 'Times-Italic', H: 'Helvetica' };
const WIN = { 0x20AC:0x80,0x201A:0x82,0x0192:0x83,0x201E:0x84,0x2026:0x85,0x2020:0x86,0x2021:0x87,0x02C6:0x88,0x2030:0x89,0x0160:0x8A,0x2039:0x8B,0x0152:0x8C,0x017D:0x8E,0x2018:0x91,0x2019:0x92,0x201C:0x93,0x201D:0x94,0x2022:0x95,0x2013:0x96,0x2014:0x97,0x02DC:0x98,0x2122:0x99,0x0161:0x9A,0x203A:0x9B,0x0153:0x9C,0x017E:0x9E,0x0178:0x9F };
function code(ch) {
  const u = ch.codePointAt(0);
  if (u >= 32 && u < 127) return u;
  if (u >= 160 && u <= 255) return u;
  if (WIN[u]) return WIN[u];
  return 63;
}
function width(str, f, size) {
  let t = 0;
  for (const ch of String(str)) { const c = code(ch); t += (W[f][c - 32] || 500); }
  return t * size / 1000;
}
function pdfStr(str) {
  let o = '';
  for (const ch of String(str)) {
    const c = code(ch);
    if (c === 40 || c === 41 || c === 92) o += '\\' + String.fromCharCode(c);
    else if (c < 32 || c > 126) o += '\\' + c.toString(8).padStart(3, '0');
    else o += String.fromCharCode(c);
  }
  return '(' + o + ')';
}
const n1 = (v) => (Math.round(v * 10) / 10).toString();

// ---- page geometry (US letter; 3/4-inch margins minimum) ----
const PW = 612, PH = 792, ML = 54, MR = 54, MT = 54, MB = 56;
const BODY = 11, LEAD = 13.8;
const TW = PW - ML - MR;

// Word-wrap a list of runs [{f, t}] (and blanks {blank:true, w, value, field}) into lines of positioned pieces.
function layoutRuns(runs, maxW, size, indent) {
  const toks = [];
  runs.forEach((r) => {
    if (r.blank) { toks.push({ blank: true, w: r.w, value: r.value || '', field: r.field }); return; }
    (r.u ? [r.t] : String(r.t).split(/(\s+)/)).forEach((p) => { if (p === '') return; toks.push(/^\s+$/.test(p) ? { sp: true, f: r.f } : { f: r.f, t: p, u: r.u }); });
  });
  const lines = []; let cur = []; let x = indent || 0; let pendingSp = null;
  const push = () => { lines.push(cur); cur = []; x = indent || 0; pendingSp = null; };
  toks.forEach((k) => {
    if (k.sp) { if (cur.length) pendingSp = k; return; }
    const w = k.blank ? k.w : width(k.t, k.f, size);
    const spW = pendingSp ? width(' ', pendingSp.f, size) : 0;
    if (cur.length && x + spW + w > maxW) push();
    else if (pendingSp) x += spW;
    pendingSp = null;
    cur.push(Object.assign({}, k, { x, w }));
    x += w;
  });
  if (cur.length) push();
  return lines;
}

// ---- building the flow: a list of lines {h, gap, ops(y) -> [ops], fields(y) -> [...], group, para, keepNext} ----
export function penaltyClaimPdf(model, opts) {
  const o = opts || {};
  const F = model.form;
  const flow = [];
  let paraId = 0;
  const txt = (f, size, x, y, s, gray) => (gray ? gray + ' g ' : '') + 'BT /F' + f + ' ' + size + ' Tf ' + n1(x) + ' ' + n1(y) + ' Td ' + pdfStr(s) + ' Tj ET' + (gray ? ' 0 g' : '');
  const hline = (x1, x2, y, w) => (w || 0.6) + ' w ' + n1(x1) + ' ' + n1(y) + ' m ' + n1(x2) + ' ' + n1(y) + ' l S';

  // paragraph from runs
  const para = (runs, optsP) => {
    const p = optsP || {};
    const size = p.size || BODY, ind = p.indent || 0, lead = p.lead || LEAD;
    const lines = layoutRuns(runs, TW - ind - (p.right || 0), size, 0);
    const id = ++paraId;
    lines.forEach((ln, i) => {
      flow.push({
        h: lead, gap: i === 0 ? (p.gap || 0) : 0, para: id, paraLen: lines.length, paraIdx: i, keepNext: p.keepNext, group: p.group,
        ops: (y) => ln.map((pc) => {
          const x = ML + ind + pc.x;
          if (pc.blank) return hline(x, x + pc.w, y - 2.5) + (pc.value ? ' ' + txt('R', size, x + (pc.w - width(pc.value, 'R', size)) / 2, y, pc.value) : '');
          return txt(pc.f, size, x, y, pc.t) + (pc.u ? ' ' + hline(x, x + pc.w, y - 1.8, 0.5) : '');
        }).join('\n'),
        fields: (y) => ln.filter(pc => pc.blank && pc.field && !pc.value).map(pc => ({ name: pc.field, rect: [ML + ind + pc.x, y - 2, ML + ind + pc.x + pc.w, y + size] })),
      });
    });
  };

  // ---- LETTERHEAD (page 1 only) ----
  const lhLines = F.header || [];
  flow.push({ h: 0, gap: 0, letterhead: true, ops: (y) => {
    const out = [];
    let yy = y;
    if (o.logo) {                                          // SMART logo, as on Bob's 2017 letters (2.78 x 0.46 in)
      const lw = 200, lh = lw * o.logo.h / o.logo.w;
      out.push('q ' + lw + ' 0 0 ' + n1(lh) + ' ' + n1((PW - lw) / 2) + ' ' + n1(yy - lh) + ' cm /Logo Do Q');
      yy -= lh + 13;
    }
    const motto = '* Our Union - Our Jobs - Our Lives - Our Future *';
    out.push(txt('H', 9.5, (PW - width(motto, 'H', 9.5)) / 2, yy, motto));
    yy -= 5; out.push(hline(ML, PW - MR, yy, 1.6));
    lhLines.forEach((l, i) => {
      const f = i === 0 ? 'B' : 'B', sz = i === 0 ? 11 : 10;
      yy -= sz + 2.5;
      out.push(txt(f, sz, (PW - width(l, f, sz)) / 2, yy, l));
    });
    if (F.contact) { yy -= 12.5; out.push(txt('R', 10, (PW - width(F.contact, 'R', 10)) / 2, yy, F.contact)); }
    yy -= 5; out.push(hline(ML, PW - MR, yy, 1.1));
    return out.join('\n');
  }, height: () => (o.logo ? 200 * o.logo.h / o.logo.w + 13 : 0) + 5 + lhLines.reduce((a, l, i) => a + (i === 0 ? 13.5 : 12.5), 0) + (F.contact ? 12.5 : 0) + 5 });
  flow[flow.length - 1].h = flow[flow.length - 1].height();

  // ---- CRAFT (Bob, 2026-09-29): centered under the heavy rule, above the title - from the claim itself ----
  if (F.craft) flow.push({ h: 15, asc: 11, gap: 9, keepNext: true, ops: (y) => { const c = F.craft.toUpperCase(); return txt('B', 12, (PW - width(c, 'B', 12)) / 2, y, c); } });

  // ---- TITLE ----
  flow.push({ h: 20, asc: 15, gap: F.craft ? 4 : 10, keepNext: true, ops: (y) => txt('B', 16, (PW - width(F.title, 'B', 16)) / 2, y, F.title) });
  // Section 539 (issue C-5: "The PREVIEW watermark was not understood - the missing list sits above the viewer"). A
  // preview that cannot be sent says, on the page itself, what it is waiting for.
  if (model.example) {
    para([{ f: 'B', t: 'EXAMPLE ONLY. ' }, { f: 'R', t: 'This is an example claim made for training and testing. It is not a claim and is never served on a carrier.' }], { gap: 8, size: 9.5, lead: 12 });
  }
  if (o.preview && o.sendable === false && Array.isArray(model.missing) && model.missing.length) {
    para([{ f: 'B', t: 'PREVIEW - NOT READY TO SEND. ' }, { f: 'R', t: 'Still needed before it can be signed and served: ' + model.missing.join('; ') + '.' }], { gap: 8, size: 9.5, lead: 12 });
  }

  // ---- FIELD ROWS (two columns, like Bob's form) ----
  const GAP = 22, CW = (TW - GAP) / 2;
  const fieldCell = (x0, cw, label, value, fname) => {
    const lab = label + ':';
    const lw = width(lab, 'R', BODY) + 4;
    const vLines = value ? layoutRuns([{ f: 'R', t: value }], cw - lw - 4, BODY, 0) : [[]];
    return { lines: vLines, draw: (y) => {
      const out = [txt('R', BODY, x0, y, lab)];
      vLines.forEach((ln, i) => {
        const yy = y - i * LEAD;
        out.push(hline(x0 + lw, x0 + cw, yy - 2.5, 0.5));
        ln.forEach(pc => out.push(txt('R', BODY, x0 + lw + 3 + pc.x, yy, pc.t)));
      });
      return out.join('\n');
    }, fields: (y) => (!value && fname ? [{ name: fname, rect: [x0 + lw, y - 2, x0 + cw, y + BODY] }] : []) };
  };
  F.rows.forEach((row, i) => {
    const L = fieldCell(ML, CW, row[0][0], row[0][1], row[0][2]);
    const R = fieldCell(ML + CW + GAP, CW, row[1][0], row[1][1], row[1][2]);
    const n = Math.max(L.lines.length, R.lines.length);
    flow.push({ h: LEAD * (n - 1) + LEAD + 2.5, gap: i === 0 ? 10 : 0, group: 'rows', ops: (y) => L.draw(y) + '\n' + R.draw(y), fields: (y) => L.fields(y).concat(R.fields(y)) });
  });
  F.full.forEach(([label, value], i) => {
    const c = fieldCell(ML, TW, label, value, null);
    flow.push({ h: LEAD * c.lines.length + 2.5, gap: 0, group: 'rows', ops: (y) => c.draw(y), fields: () => [] });
    // Ruling 262: the agreement's designation, printed under "Presented to".
    if (i === 0 && label === 'Presented to' && F.presentNote) para([{ f: 'I', t: F.presentNote }], { gap: 0, indent: 14, group: 'rows' });
  });

  // ---- AMOUNT / HOURS ----
  para([{ f: 'B', t: 'Amount/Hours Claimed: ' }, { blank: true, w: 46, value: F.amount.hours, field: F.amount.hours ? null : 'hoursClaimed' }, { f: 'R', t: ' ' + F.amount.text }], { gap: 6 });
  // Total amount owed, from the claim itself (Bob, 2026-09-29). Blank line when the claim holds no amount.
  para([{ f: 'B', t: 'Total Amount Claimed: ' }, { blank: true, w: 90, value: F.amount.total || '', field: F.amount.total ? null : 'totalAmountClaimed' }], { gap: 3 });

  // ---- STANDING SENTENCE ----
  para([{ f: 'R', t: F.standing }], { gap: 6 });

  // ---- SUBSTANCE OF CLAIM ----
  para([{ f: 'B', t: 'Substance of Claim:', u: true }], { gap: 10, keepNext: true });
  F.substance.forEach((s, i) => {
    const runs = s.label ? [{ f: 'B', t: s.label + (s.text ? ' ' : '') }].concat(s.text ? [{ f: 'R', t: s.text }] : []) : [{ f: 'R', t: s.text }];
    if (s.label || s.text) para(runs, { gap: i === 0 ? 3 : 3, keepNext: !!s.quote });   // Record 607: a continuing paragraph of the same rule has no heading line
    if (s.quote) para([{ f: 'I', t: '“' + s.quote + '”' }], { gap: 3, indent: 24, right: 12 });
  });

  // ---- CLOSING ----
  para([{ f: 'R', t: F.closing }], { gap: 9 });

  // ---- ATTACHMENTS ----
  if (F.attachments.length) {
    para([{ f: 'B', t: 'Attachments supporting claim:', u: true }], { gap: 9, keepNext: true });
    F.attachments.forEach((a, i) => para([{ f: 'R', t: (i + 1) + '.  ' + a }], { gap: i === 0 ? 4 : 1, indent: 14 }));
  }

  // ---- PAYMENT + SIGNATURES: one group, never split, never alone ----
  const g = 'sig';
  const pay = F.payment;
  const cut = pay.indexOf(' because ');
  para(cut > 0 ? [{ f: 'B', t: pay.slice(0, cut) }, { f: 'R', t: pay.slice(cut) }] : [{ f: 'B', t: pay }], { gap: 10, group: g });
  const sigRow = (leftLabel, rightLabel, rightField, gap) => flow.push({ h: 26, gap, group: g, ops: (y) => [
      hline(ML, ML + 300, y, 0.7), txt('R', 10.5, ML, y - 12, leftLabel),
      hline(ML + 324, PW - MR, y, 0.7), txt('R', 10.5, ML + 324, y - 12, rightLabel)].join('\n'),
    fields: (y) => [{ name: rightField, rect: [ML + 324, y + 1, PW - MR, y + 15] }] });
  // SIGNER BLOCKS (ruling 260): whoever submits signs. The claimant's block when she signs; the filing officer's
  // block when an officer submits. Under each: name and title, mailing address, and - under the one who submits
  // it - the line telling the carrier where to reply. A blank address prints blank lines, never a guess.
  (F.signers || []).forEach((sg, k) => {
    const lines = [sg.nameLine].concat(sg.address.length ? sg.address : ['', '']).concat(sg.contact ? [sg.contact] : []);
    const note = sg.submits ? 'Direct all correspondence on this claim to the address above.' : '';
    flow.push({ h: 26 + LEAD * lines.length + (note ? LEAD : 0), gap: k === 0 ? 26 : 16, group: g, ops: (y) => {
      const out = [hline(ML, ML + 300, y, 0.7), txt('R', 10.5, ML, y - 12, 'Signature'),
        hline(ML + 324, PW - MR, y, 0.7), txt('R', 10.5, ML + 324, y - 12, 'Date')];
      lines.forEach((l, i) => { const yy = y - 26 - i * LEAD; if (l) out.push(txt(i === 0 ? 'B' : 'R', BODY, ML, yy, l)); else out.push(hline(ML, ML + 240, yy - 2, 0.4)); });
      if (note) out.push(txt('I', BODY, ML, y - 26 - lines.length * LEAD, note));
      return out.join('\n');
    }, fields: (y) => [{ name: sg.field + 'Date', rect: [ML + 324, y + 1, PW - MR, y + 15] }]
      .concat(sg.address.length ? [] : [{ name: sg.field + 'Address1', rect: [ML, y - 26 - LEAD - 3, ML + 240, y - 26 - LEAD + 10] }, { name: sg.field + 'Address2', rect: [ML, y - 26 - 2 * LEAD - 3, ML + 240, y - 26 - 2 * LEAD + 10] }]) });
  });
  // Section 537: the property's own receipt line, or none. Default: the hand receipt.
  const rc = F.receipt === undefined ? { left: "Recipient’s Signature & Title", right: 'Date & Time Received' } : F.receipt;
  if (rc) sigRow(rc.left, rc.right, 'receivedDateTime', 20);
  if (F.serviceNote) para([{ f: 'I', t: F.serviceNote }], { gap: 6, group: g });
  // Certified-mail number: removed with the old standing sentence (Bob, 2026-09-29). When a claim is mailed, the
  // mail receipt itself is saved with the case (point 7).

  // ---- PAGINATE ----
  const pages = [];
  const newPage = () => { pages.push({ items: [] }); return PH - MT; };
  let y = newPage();
  const bottom = MB;
  const chunkHeight = (i) => {
    const L = flow[i];
    if (L.group && (i === 0 || flow[i - 1].group !== L.group)) {
      let h = 0, j = i; while (j < flow.length && flow[j].group === L.group) { h += flow[j].h + (j === i ? 0 : flow[j].gap); j++; } return h;
    }
    if (L.keepNext && i + 1 < flow.length) return L.h + flow[i + 1].gap + chunkHeight(i + 1);
    if (L.para && L.paraIdx === 0) { const n = L.paraLen <= 3 ? L.paraLen : 2; return L.h * n; }
    if (L.para && L.paraLen - L.paraIdx === 2) return L.h * 2;
    return L.h;
  };
  flow.forEach((L, i) => {
    const first = pages[pages.length - 1].items.length === 0;
    const gap = first ? 0 : L.gap;
    if (!first && y - gap - chunkHeight(i) < bottom) y = newPage();
    const top = pages[pages.length - 1].items.length === 0;
    y -= (top ? 0 : L.gap);
    const baseline = L.letterhead ? y : y - (L.asc || BODY);
    pages[pages.length - 1].items.push({ L, y: baseline });
    y -= L.h;
  });

  // ---- RENDER PAGES ----
  const total = pages.length;
  const pageOps = [], pageFields = [];
  pages.forEach((p, pi) => {
    const ops = [];
    if (o.preview || model.example) {
      // Record 662: an example claim's mark outranks the preview's - it is never a claim, ready or not.
      const wm = model.example ? 'EXAMPLE ONLY - NOT A REAL CLAIM' : o.sendable === false ? 'PREVIEW - NOT READY TO SEND' : 'PREVIEW', sz = 30, wl = width(wm, 'B', sz);
      ops.push('q 0.95 0.80 0.80 rg BT /FB ' + sz + ' Tf 0.819 0.574 -0.574 0.819 ' + n1(PW / 2 - 0.819 * wl / 2) + ' ' + n1(PH / 2 - 0.574 * wl / 2) + ' Tm ' + pdfStr(wm) + ' Tj ET Q');
    }
    // Pages after the first carry no header (Bob, 2026-09-29): the footer already names the claim, the claimant
    // and "Page X of Y" on every page.
    const flds = [];
    p.items.forEach(({ L, y: by }) => { ops.push(L.ops(by)); if (L.fields) L.fields(by).forEach(f => { if (f) flds.push(f); }); });
    const id = 'Claim ' + F.number + '   ·   ' + F.claimant + '   ·   Page ' + (pi + 1) + ' of ' + total;
    ops.push(hline(ML, PW - MR, 50, 0.4));
    ops.push(txt('R', 9, (PW - width(id, 'R', 9)) / 2, 39, id));
    ops.push(txt('R', 8, (PW - width(F.footer, 'R', 8)) / 2, 28, F.footer, '0.4'));
    pageOps.push(ops.join('\n'));
    pageFields.push(flds);
  });

  // ---- ASSEMBLE ----
  const objs = [];
  const add = (s) => { objs.push(s); return objs.length; };
  const catalog = add(null), pagesObj = add(null);
  const fonts = {};
  ['R', 'B', 'I', 'H'].forEach((k) => { fonts[k] = add('<< /Type /Font /Subtype /Type1 /BaseFont /' + FONT_NAME[k] + ' /Encoding /WinAnsiEncoding >>'); });
  let logoRef = 0;
  const binParts = {};                                       // object index -> raw bytes to splice
  if (o.logo) {
    logoRef = add(null);
    binParts[logoRef] = o.logo.bytes;
  }
  const res = '<< /Font << /FR ' + fonts.R + ' 0 R /FB ' + fonts.B + ' 0 R /FI ' + fonts.I + ' 0 R /FH ' + fonts.H + ' 0 R >>' + (logoRef ? ' /XObject << /Logo ' + logoRef + ' 0 R >>' : '') + ' >>';
  const kids = [], allFields = [];
  pageOps.forEach((content, pi) => {
    const c = add('<< /Length ' + content.length + ' >>\nstream\n' + content + '\nendstream');
    const pageRef = add(null);
    const annots = pageFields[pi].map((f, k) => {
      const nm = f.name + (pageFields[pi].filter(x => x.name === f.name).length > 1 ? '_' + k : '');
      const r = add('<< /Type /Annot /Subtype /Widget /FT /Tx /T ' + pdfStr(nm) + ' /V () /F 4 /Ff 0 /Rect [' + f.rect.map(n1).join(' ') + '] /P ' + pageRef + ' 0 R /DA (/FR 11 Tf 0 g) /MK << >> /Border [0 0 0] >>');
      allFields.push(r); return r;
    });
    objs[pageRef - 1] = '<< /Type /Page /Parent ' + pagesObj + ' 0 R /MediaBox [0 0 ' + PW + ' ' + PH + '] /Resources ' + res + ' /Contents ' + c + ' 0 R' + (annots.length ? ' /Annots [' + annots.map(a => a + ' 0 R').join(' ') + ']' : '') + ' >>';
    kids.push(pageRef);
  });
  objs[catalog - 1] = '<< /Type /Catalog /Pages ' + pagesObj + ' 0 R' + (allFields.length ? ' /AcroForm << /Fields [' + allFields.map(a => a + ' 0 R').join(' ') + '] /NeedAppearances true /DA (/FR 11 Tf 0 g) /DR << /Font << /FR ' + fonts.R + ' 0 R >> >> >>' : '') + ' >>';
  objs[pagesObj - 1] = '<< /Type /Pages /Kids [' + kids.map(k => k + ' 0 R').join(' ') + '] /Count ' + kids.length + ' >>';
  const info = add('<< /Title ' + pdfStr(F.title + ' - Claim ' + F.number) + ' /Producer (Labor On The Record) >>');

  // byte assembly (the logo is binary; everything else is 8-bit text)
  const chunks = []; let len = 0; const offs = [];
  const pushStr = (s) => { const b = new Uint8Array(s.length); for (let i = 0; i < s.length; i++) b[i] = s.charCodeAt(i) & 0xff; chunks.push(b); len += b.length; };
  const pushBin = (b) => { chunks.push(b); len += b.length; };
  pushStr('%PDF-1.4\n%\xE2\xE3\xCF\xD3\n');
  objs.forEach((s, i) => {
    offs.push(len);
    if (binParts[i + 1]) {
      const b = binParts[i + 1];
      pushStr((i + 1) + ' 0 obj\n<< /Type /XObject /Subtype /Image /Width ' + o.logo.w + ' /Height ' + o.logo.h + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Interpolate true /Length ' + b.length + ' >>\nstream\n');
      pushBin(b); pushStr('\nendstream\nendobj\n');
    } else pushStr((i + 1) + ' 0 obj\n' + s + '\nendobj\n');
  });
  const xref = len;
  pushStr('xref\n0 ' + (objs.length + 1) + '\n0000000000 65535 f \n' + offs.map(n => String(n).padStart(10, '0') + ' 00000 n \n').join(''));
  pushStr('trailer\n<< /Size ' + (objs.length + 1) + ' /Root ' + catalog + ' 0 R /Info ' + info + ' 0 R >>\nstartxref\n' + xref + '\n%%EOF');
  const bytes = new Uint8Array(len); let p = 0; chunks.forEach(c => { bytes.set(c, p); p += c.length; });
  return { bytes, pages: total };
}
